import { render, staticRenderFns } from "./SemenCollectionEdit.vue?vue&type=template&id=fb7e4342&scoped=true&"
import script from "./SemenCollectionEdit.vue?vue&type=script&lang=js&"
export * from "./SemenCollectionEdit.vue?vue&type=script&lang=js&"
import style0 from "./SemenCollectionEdit.vue?vue&type=style&index=0&id=fb7e4342&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb7e4342",
  null
  
)

export default component.exports